import {
  ACTIVE,
  DISABLED,
  HIDDEN,
  INVALID
} from '../../classnames/design-system';
import { SELECTORS } from './constants';

export class SelectDropdownUI {
  constructor(container) {
    this.container = container;
    this.select = container.querySelector(`.${SELECTORS.CUSTOM}`);
    this.label = container.querySelector(`.${SELECTORS.LABEL}`);
    this.selectedOption = container.querySelector(`.${SELECTORS.SELECTED_OPTION}`);
    this.optionsContainer = container.querySelector(`.${SELECTORS.OPTIONS}`);
    this.options = container.querySelectorAll(`.${SELECTORS.OPTION}`);
    this.labelText = this.label?.textContent;
  }

  highlightSelectedOption = (selectedValue) => {
    this.options.forEach((option) => {
      const currentValue = option.dataset.value;

      if (currentValue === selectedValue) {
        option.classList.add(ACTIVE);
      } else {
        option.classList.remove(ACTIVE);
      }
    });
  };

  setSelectedOptionText = (text) => {
    this.selectedOption.innerHTML = text;
  };

  setDefaultOption = (option) => {
    const currentOption = this.container.querySelector(`.${SELECTORS.OPTION}[data-value="${option.value}"]`);

    this.setSelectedOption(currentOption);
  };

  setSelectedOption = (option) => {
    this.setSelectedOptionText(option.innerHTML);
    this.highlightSelectedOption(option.dataset.value);
  };

  clearDisabledOptionState = () => {
    this.selectedOption.classList.remove(HIDDEN);
  };

  clearLabelState = () => {
    if (this.label) {
      this.label.classList.remove(DISABLED);
      this.label.classList.remove(INVALID);
      this.label.innerText = this.labelText;
    }
  };

  selectOption = (option) => {
    this.setSelectedOption(option);
    this.clearDisabledOptionState();
    this.clearLabelState();
  };

  toggleOptions = () => {
    this.optionsContainer.classList.toggle(ACTIVE);
    this.select.classList.toggle(ACTIVE);
  };

  hideOptions = () => {
    this.optionsContainer.classList.remove(ACTIVE);
    this.select.classList.remove(ACTIVE);
  };
}
